"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFCERT_CONTACT = exports.MNEMONIC_CONTACT = void 0;
exports.MNEMONIC_CONTACT = {
    address: "Henrik Ibsens gate 100, 0255 OSLO",
    email: "mss@mnemonic.no",
    name: "mnemonic as",
    phoneNumber: ["+4723204747", "+4723202825"],
    shortname: "mnemonic",
    theme: "mnemonic",
};
exports.NFCERT_CONTACT = {
    address: "Hansteens gate 2, 0253 OSLO",
    email: "post@nfcert.org",
    name: "Nordic Financial CERT",
    phoneNumber: [],
    shortname: "NFCERT",
    theme: "nfcert",
};
/**
 * @internal
 */
const config = {
    argusweb: {
        env: "production",
        envZone: "internal",
        apiUrl: `https://api.mnemonic.no`,
        baseUrl: "https://argusweb.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://argusweb.mnemonic.no/spa",
        staticUrl: `https://static.mnemonic.no/mnemonic/v1/`,
        domains: {
            static: "https://static.mnemonic.no",
            api: "https://api.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-signatures1.mnemonic.no`,
        },
    },
    /**
     * Host used while developing apps intended to be displayed
     * as a webview in the mobile application.
     */
    "osl-dev-gw1.mnemonic.no": {
        env: "local",
        envZone: "internal",
        apiUrl: "https://devapi.mnemonic.no",
        baseUrl: "https://osl-dev-gw1.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: `https://${window.location.host}`,
        staticUrl: "https://osl-argus-trunk-static1.mnemonic.no/mnemonic/v1/",
        domains: {
            static: "https://osl-argus-trunk-static1.mnemonic.no",
            api: "https://devapi.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-dev-signatures1.mnemonic.no`,
        },
    },
    "local.mtest.no": {
        env: "local",
        envZone: "internal",
        apiUrl: "https://devapi.mnemonic.no",
        baseUrl: "https://local.mtest.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://local.mtest.no/spa",
        staticUrl: "https://osl-argus-trunk-static1.mnemonic.no/mnemonic/v1/",
        domains: {
            static: "https://osl-argus-trunk-static1.mnemonic.no",
            api: "https://devapi.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-dev-signatures1.mnemonic.no`,
        },
    },
    "localhost.mnemonic.no": {
        env: "local",
        envZone: "internal",
        apiUrl: "https://devapi.mnemonic.no",
        baseUrl: "https://localhost.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        /**
         * We check if WEBPACK_SERVE is set to see if we are running webpack devserver. If so, we do not use the "spa" suffix
         * in the spaUrl here.
         */
        spaUrl: typeof WEBPACK_SERVE !== "undefined" ? `https://${window.location.host}` : "https://localhost.mnemonic.no/spa",
        staticUrl: "https://osl-argus-trunk-static1.mnemonic.no/mnemonic/v1/",
        domains: {
            static: "https://osl-argus-trunk-static1.mnemonic.no",
            api: "https://devapi.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-dev-signatures1.mnemonic.no`,
        },
    },
    localhost: {
        env: "local",
        envZone: "internal",
        apiUrl: `https://devapi.mnemonic.no`,
        baseUrl: "http://localhost",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "http://localhost",
        staticUrl: `https://osl-argus-trunk-static1.mnemonic.no/mnemonic/v1/`,
        domains: {
            static: "https://osl-argus-trunk-static1.mnemonic.no",
            api: "https://devapi.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-dev-signatures1.mnemonic.no`,
        },
    },
    "osl-argus-staging-web1": {
        env: "staging",
        envZone: "internal",
        apiUrl: `https://api.mnemonic.no`,
        baseUrl: "https://osl-argus-staging-web1.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://osl-argus-staging-web1.mnemonic.no/spa",
        staticUrl: `https://static.mnemonic.no/mnemonic/v1/`,
        domains: {
            static: "https://static.mnemonic.no",
            api: "https://api.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-signatures1.mnemonic.no`,
        },
    },
    "osl-argusdev-portal1": {
        env: "test",
        envZone: "internal",
        apiUrl: "https://devapi.mnemonic.no",
        baseUrl: "https://osl-argusdev-portal1.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://osl-argusdev-portal1.mnemonic.no/spa",
        staticUrl: "https://osl-argus-trunk-static1.mnemonic.no/mnemonic/v1/",
        domains: {
            static: "https://osl-argus-trunk-static1.mnemonic.no",
            api: "https://devapi.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-dev-signatures1.mnemonic.no`,
        },
    },
    "osl-dockerweb1": {
        env: "test",
        envZone: "internal",
        apiUrl: "https://argus.mtest.no",
        baseUrl: "https://argus.mtest.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://argus.mtest.no/spa",
        staticUrl: "https://osl-dockerstatic1.mtest.no/mnemonic/v1/",
        domains: {
            static: "https://osl-dockerstatic1.mtest.no",
            api: "https://argus.mtest.no",
        },
        thirdParty: {
            signatures: `https://osl-signatures1.mtest.no`,
        },
    },
    "passivedns.mnemonic.no": {
        env: "production",
        envZone: "external",
        apiUrl: `https://api.mnemonic.no`,
        baseUrl: "https://passivedns.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://portal.mnemonic.no/spa",
        staticUrl: `https://static.mnemonic.no/mnemonic/v1`,
        domains: {
            static: "https://static.mnemonic.no",
            api: "https://api.mnemonic.no",
        },
        thirdParty: {},
    },
    "passivedns.mnemonic.io": {
        env: "production",
        envZone: "external",
        apiUrl: `https://api.mnemonic.io`,
        baseUrl: "https://passivedns.mnemonic.io",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://portal.mnemonic.io/spa",
        staticUrl: `https://static.mnemonic.io/mnemonic/v1`,
        domains: {
            static: "https://static.mnemonic.io",
            api: "https://api.mnemonic.io",
        },
        thirdParty: {},
    },
    "portal.mnemonic.io": {
        env: "production",
        envZone: "external",
        apiUrl: `https://api.mnemonic.io`,
        baseUrl: "https://portal.mnemonic.io",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://portal.mnemonic.io/spa",
        staticUrl: `https://static.mnemonic.io/mnemonic/v1/`,
        domains: {
            static: "https://static.mnemonic.io",
            api: "https://api.mnemonic.io",
        },
        thirdParty: {
            signatures: `https://osl-signatures1.mnemonic.no`,
        },
    },
    "portal.mnemonic.no": {
        env: "production",
        envZone: "external",
        apiUrl: `https://api.mnemonic.no`,
        baseUrl: "https://portal.mnemonic.no",
        domain: "MNEMONIC",
        metaInfo: exports.MNEMONIC_CONTACT,
        spaUrl: "https://portal.mnemonic.no/spa",
        staticUrl: `https://static.mnemonic.no/mnemonic/v1/`,
        domains: {
            static: "https://static.mnemonic.no",
            api: "https://api.mnemonic.no",
        },
        thirdParty: {
            signatures: `https://osl-signatures1.mnemonic.no`,
        },
    },
    "portal.nfcert": {
        env: "production",
        envZone: "external",
        apiUrl: "https://api.nfcert.org",
        baseUrl: "https://portal.nfcert.org",
        domain: "NFCERT",
        metaInfo: exports.NFCERT_CONTACT,
        spaUrl: "https://portal.nfcert.org/spa",
        staticUrl: "https://static.mnemonic.no/mnemonic/v1/",
        domains: {
            static: "https://static.mnemonic.io",
            api: "https://api.nfcert.org",
        },
        thirdParty: {},
    },
};
exports.default = config;
